export enum UserChangesMade {
	None,
	AddedRole,
	DeletedRole,
	UpdatedUserInformation,
}